import { appDomain } from "../../domain/AppDomain";
import { ICalendar } from "../../domain/calendars/ICalendar";
import { IEmployeeGroupAbsences } from "../../domain/employeeGroups/IEmployeeGroupAbsences";
import { IEmployeeRepository } from "../../domain/employees/IEmployeeRepository";
import { IUserInfo } from "../../domain/users/IUserInfo";
import { restApiHelper } from "../helpers/RestApiHelper";
import { mapCalendar } from "./Mappers/mapCalendar";
import { mapEmployeeGroupAbsences } from './Mappers/mapEmployeeGroupAbsences';

export class EmployeeRepository implements IEmployeeRepository {
    async getEmployeeGroupAbsences(): Promise<IEmployeeGroupAbsences[]> {
        const absenceForMonth = await restApiHelper.getData(`api/employees/grouped`, {});
        return absenceForMonth.map(mapEmployeeGroupAbsences);
    }

    async getUserInfo(): Promise<IUserInfo> {
        const userinfo = await restApiHelper.getData("api/users/info", {});
        return userinfo as IUserInfo;
    }

    async getAllCalendars(): Promise<ICalendar[]> {
        const absenceForMonth = await restApiHelper.getData(`api/calendars`, {});
        return absenceForMonth.map(mapCalendar);
    }

    async getEmployeeAbsenceInfos(): Promise<ICalendar[]> {
        var employees = await this.getAllCalendars();
        return employees.map(e => {
            return {
                id: e.id,
                name: e.name,
                calendarEvents: [],
                status: 0,
                userType: e.userType,
                meetingEnd: null,
            } as ICalendar;
        });
    }

    async getAbsencesForAbsentPresentOverview(): Promise<IEmployeeGroupAbsences[]> {
        const data = await restApiHelper.getData(`api/employees/grouped/bhv`, {});
        var dataWithoutTotals = data.map(mapEmployeeGroupAbsences);

        dataWithoutTotals.forEach((group: any) => {
            group.available = group.employees.filter((a: any) => appDomain.IEmployeeAbsenceService.isAvailableStatus(a.status)).length;
            group.total = group.employees.length;
        });

        return dataWithoutTotals;
    }
}
